import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { PaymentLinkState } from './types';
import {
  PaymentLink,
  PaymentLinkBuyerDetails,
  PaymentLinkOwner,
  PaymentLinkSellerProfile,
  PaymentLinkStatus,
} from 'payment-link/types';

import { RootState } from '../store';

const initialState: PaymentLinkState = {};

export const paymentLinkSlice = createSlice({
  name: 'payment-link',
  initialState,
  reducers: {
    resetStore: (state) => {
      state = initialState;
      return state;
    },
    setPaymentLinkDetails: (state, action: PayloadAction<PaymentLink | undefined>) => {
      state.linkDetails = action.payload;
    },
    setPaymentLinkOwner: (state, action: PayloadAction<PaymentLinkOwner | undefined>) => {
      state.owner = action.payload;
    },
    setPaymentLinkInvoiceId: (state, action: PayloadAction<string | undefined>) => {
      state.invoiceId = action.payload;
    },
    /**
     * @deprecated - remove
     */
    setPaymentLinkSellerProfile: (
      state,
      action: PayloadAction<PaymentLinkSellerProfile | undefined>,
    ) => {
      state.sellerProfile = action.payload;
    },
    setPaymentLinkBuyerDetail: (
      state,
      action: PayloadAction<PaymentLinkBuyerDetails | undefined>,
    ) => {
      state.buyer = action.payload;
    },
  },
});

// Selectors
const getPaymentLinkState = (state: RootState): PaymentLinkState => state.paymentLink;
export const getPaymentLinkDetails = createSelector(
  getPaymentLinkState,
  (pmLink) =>
    pmLink.linkDetails ??
    ({
      externalReferenceId: '',
      amount: -1,
      currency: 'USD',
      title: '',
      name: '',
      description: '',
      status: PaymentLinkStatus.ACTIVE,
    } as PaymentLink),
);
export const getPaymentLinkOwner = createSelector(
  getPaymentLinkState,
  (pmLink) => pmLink.owner ?? ({ name: '' } as PaymentLinkOwner),
);

/**
 * @deprecated - remove
 */
export const getPaymentLinkSellerProfile = createSelector(
  getPaymentLinkState,
  (pmLink) => pmLink.sellerProfile ?? ({} as PaymentLinkSellerProfile),
);

export const getPaymentLinkInvoiceId = createSelector(
  getPaymentLinkState,
  (pmLink) => pmLink.invoiceId ?? ({} as string),
);

export const getPaymentLinkBuyer = createSelector(
  getPaymentLinkState,
  (pmLink) => pmLink.buyer ?? ({} as PaymentLinkBuyerDetails),
);

const { actions, reducer } = paymentLinkSlice;

export const {
  setPaymentLinkInvoiceId,
  setPaymentLinkDetails,
  setPaymentLinkOwner,
  setPaymentLinkSellerProfile,
  setPaymentLinkBuyerDetail,
  resetStore: paymentLinkReset,
} = actions;

export default reducer;
